import React from "react";
import "./Page404.css";

import Img from "../Img/404-error.webp";
import { Link } from "react-router-dom";
import { DoubleLeftOutlined } from "@ant-design/icons";

export default function Page404() {
  return (
    <div className="Page404-Body">
      <div className="Page404-Box">
        <div className="Page404-Left">
        <div className="Page404-Right2">
          <img alt="" src={Img} className="Page404-Img" />
        </div>
          <p className="Page404-Text1">Sorry!</p>
          <p className="Page404-Text2">This Page is Not Found.</p>
          <p className="Page404-Text3">
            Lorem Ipsum is simply dummy text of the printing and dard dummy text
            ever since the 1500 when an uniknown specimen book has not only
            five.
          </p>
          <Link to='/' className="Page404-Link">
            <DoubleLeftOutlined />
            Back to Home
          </Link>
        </div>
        <div className="Page404-Right">
          <img alt="" src={Img} className="Page404-Img" />
        </div>
      </div>
    </div>
  );
}
